<template>
  <!-- <div class="vw-100 min-vw-100 vh-100 min-vh-100 p-0 m-0">
    <notifications position="bottom left" />

    <LoginDialog />
    <LoadingDialog />
    <component :is="getBaseComponent"></component>
  </div> -->

  <router-view></router-view>
</template>

<script>
  /**
   * Entry point of VJS.
   * Dynamically accepts a 'view' (base component) that effectively acts as a template for a given view.
   * Contains global components that are used throughout the application.
   */

  // Include the base templates that will replace the 'getBaseComponent'.
  // import BaseTemplate from '@/layouts/BaseTemplate.vue';
  // import DashboardBaseTemplate from '@/layouts/DashboardBaseTemplate.vue';
  

  // Include the global Login/Message/Loading dialogs.
  // import LoginDialog from '@/components/dialogs/LoginDialog.vue';
  // import MessageDialog from '@/components/dialogs/MessageDialog.vue';
  // import LoadingDialog from '@/components/dialogs/LoadingDialog.vue';

  import {
    mapGetters,
    mapActions
  } from 'vuex';

  export default {
    data() {
      return {
        tokenExpiryTimer: null,
      };
    },
    // Set the base templates and dialogs as components.
    components: {
      // BaseTemplate,
      // DashboardBaseTemplate,
      // BlankBaseTemplate,
      // LoginDialog,
      // MessageDialog,
      // LoadingDialog
    },
    computed: {
      // Map the base component getters and is authenticated getters.
      ...mapGetters([
        'getBaseComponent',
        'isAuthenticated'
      ])
    },
    async created() {
      // Restores an unexpired persisted token, if there is one.
      //await this.initAuthorizationToken();
      this.scheduleTokenExpiry();
    },
    beforeDestroy() {
      clearTimeout(this.tokenExpiryTimer);
    },
    watch: {
    // Re-evaluate whenever the user navigates between public/protected pages.
      $route() {
        this.scheduleTokenExpiry();
      },
    },
    methods: {
      // Map the base template actions.
      ...mapActions([
        "setBaseComponent",
        "initAuthorizationToken",
        "clearAuthorizationToken",
      ]),
      routeRequiresAuth() {
        return this.$route.matched.some(
          record => record.meta.requiresAuth
        );
      },
      scheduleTokenExpiry() {
        clearTimeout(this.tokenExpiryTimer);
        // Do nothing on public routes such as login or password reset.
        if (!this.routeRequiresAuth()) {
          return;
        }
        const expiresAt = Number(
          localStorage.getItem("authorizationExpiresAt")
        );
        const remainingMs = expiresAt - Date.now();
        if (!this.isAuthenticated || remainingMs <= 0) {
          this.redirectExpiredUserToLogin();
          return;
        }
        this.tokenExpiryTimer = window.setTimeout(
          this.redirectExpiredUserToLogin,
          remainingMs
        );
      },
      redirectExpiredUserToLogin() {
        this.clearAuthorizationToken();
        // Do not redirect public routes, even if an old timer somehow fires.
        if (!this.routeRequiresAuth()) {
          return;
        }
        this.$router.replace({
          name: "login",
          query: {
            next: this.$route.fullPath,
          },
        });
      },
    }
  }
</script>


<style lang="scss">
@import 'assets/css/custom.scss';

  :root {
      --vb_offwhite: #fcf6eb;
      --vb_blue: #64abce;
      --vb_blue_focus: #5097BA;
      --vb_red: #e33a30;
      --vb_green: #57c170
  }
  
  .vt-table-cell {
    margin: auto !important;
    padding: 3px !important;
    font-size: small !important;
    // width: 150px !important;
    max-width: 100px;
  }
  .vt-table-cell-mid {
    margin: auto !important;
    padding: 3px !important;
    font-size: small !important;
    min-width: 110px;
  }
  .vt-table-cell-wide {
    margin: auto !important;
    padding: 3px !important;
    font-size: small !important;
    min-width: 200px;
    max-width: 400px;
  }
  .vt-table-rows:hover > td {
    background-color: var(--vb_blue) !important;
    border-color: var(--vb_blue) !important;
    color: white;
  }
  .center-checkbox{
    text-align: center;
    padding-left: 12px !important; // this is because the checkbox has some space to the right side of it...
  }
  .text-underline {
    text-decoration: underline;
  }
  .text-underline:hover {
    font-weight: bold;
  }
  .btn-primary {
    background-color: var(--vb_blue) !important;
    border-color: var(--vb_blue) !important;
  }
  .page-item.active .page-link {
    background-color: var(--vb_blue);
    border-color: var(--vb_blue);
  }
  .page-link {
    color: var(--vb_blue);
  }
  .button-link {
    color: white !important;
  }
  .btn-primary:focus {
    background-color: var(--vb_blue_focus) !important;
  }
  .btn-primary:hover {
    background-color: var(--vb_blue_focus) !important;
  }

  .btn-success {
    background: var(--vb_green)
  }
  .btn-danger {
    background: var(--vb_red)
  }

  .color-box {
    width: 40px;
    height: 20px;
    display: inline-block;
  }

  .flex-wrapper {
    display: flex;
    flex-flow: column;
    height: 100vh;
  }

  .flex-wrapper .flex-row.height-by-content {
    flex: 0 0 auto;
    /* The above is shorthand for:
    flex-grow: 0,
    flex-shrink: 1,
    flex-basis: auto
    */
  }

  .flex-wrapper .flex-row.content {
    flex: 1 1 auto;
  }

  .flex-wrapper .flex-row.fixed-height {
    flex: 0 1 40px;
  }
</style>